export const onDelete = id => ({
  widget: 'tokens',
  type: 'onDelete',
  payload: { id },
})



// WEBPACK FOOTER //
// ./src/tokens/actions/onDelete.js